/* Native details remain usable without JS; this adds dismissal and consistent focus. */
(() => {
  const initialize = (root) => {
    if (root.__wxRangeController) return;
    const controller = new AbortController();
    root.__wxRangeController = controller;
    const options = { signal: controller.signal };
    const menus = Array.from(root.querySelectorAll('[data-wx-range-menu]'));
    const desktop = window.matchMedia('(min-width: 1120px)');
    const update = (menu) => {
      menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open));
    };
    const close = (menu, restoreFocus = false) => {
      if (!menu.open) return;
      menu.open = false;
      update(menu);
      if (restoreFocus) menu.querySelector(':scope > summary')?.focus();
    };
    menus.forEach((menu) => {
      update(menu);
      menu.addEventListener('toggle', () => {
        update(menu);
        if (menu.open) menus.forEach((other) => { if (other !== menu) close(other); });
      }, options);
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !menu.open) return;
        event.preventDefault();
        event.stopPropagation();
        close(menu, true);
      }, options);
      menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) close(menu);
      }, options);
    });
    document.addEventListener('pointerdown', (event) => {
      menus.forEach((menu) => { if (!menu.contains(event.target)) close(menu); });
    }, options);
    document.addEventListener('focusin', (event) => {
      menus.forEach((menu) => { if (!menu.contains(event.target)) close(menu); });
    }, options);
    desktop.addEventListener('change', () => menus.forEach((menu) => close(menu)), options);
    root.addEventListener('wx:range:disconnect', () => {
      controller.abort();
      delete root.__wxRangeController;
    }, { once: true });
  };
  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-wx-range-root]')) initialize(scope);
    scope.querySelectorAll('[data-wx-range-root]').forEach(initialize);
  };
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const roots = event.target.matches?.('[data-wx-range-root]') ? [event.target] : Array.from(event.target.querySelectorAll('[data-wx-range-root]'));
    roots.forEach((root) => root.dispatchEvent(new Event('wx:range:disconnect')));
  });
})();
